import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String
  }

  declare textValue: string

  copy(event: Event) {
    event.preventDefault()

    const button = event.currentTarget as HTMLElement
    const originalHTML = button.innerHTML

    navigator.clipboard.writeText(this.textValue).then(() => {
      button.innerHTML = '<i class="fas fa-check mr-1"></i>Kopiert!'
      button.classList.add('btn-success')

      setTimeout(() => {
        button.innerHTML = originalHTML
        button.classList.remove('btn-success')
      }, 2000)
    }).catch(err => {
      console.error('Failed to copy text: ', err)
      button.innerHTML = originalHTML
    })
  }
}
